import React from 'react';
import styled from 'styled-components';
import { max } from 'd3-array';

import { getRScale, translate, numberFormat } from '~/utils';

const LegendCircle = styled.circle`
  stroke: #777;
  fill: none;
`;

const LegendLine = styled.line`
  shape-rendering: crispEdges;
  stroke: #111;
`;

const LegendText = styled.text`
  text-align: center;
  color: #777;
  font-size: 10px;
`;

const LegendStep = ({ step, r, width, height, rMax }) => {
  const radius = r(step);

  return (
    <g transform={translate(rMax + 2, height - radius - 1)}>
      <LegendCircle r={radius} cx={0} cy={0} />
      <LegendLine x1={0} x2={rMax * 1.5} y1={0} y2={0} />
      <LegendText x={rMax * 1.5 + 3} y={0} dy={2}>
        {numberFormat(step)}
      </LegendText>
    </g>
  );
};

const Legend = () => {
  const width = 100;
  const marginBottom = 20;
  const r = getRScale();
  const legendSteps = [100000, 1000000];
  const rMax = max(legendSteps, (d) => r(d));
  const height = rMax * 2 + 2 + marginBottom;

  return (
    <svg width={width} height={height}>
      {legendSteps.map((step) => (
        <LegendStep
          rMax={rMax}
          r={r}
          step={step}
          width={width}
          height={height - marginBottom}
          key={step}
        />
      ))}
      <LegendText textAnchor="start" x={0} y={height - 5}>
        Anzahl Beschäftigte
      </LegendText>
    </svg>
  );
};

export default Legend;
